import { Box, Typography, Stack, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import noSearchResults from "../../../../../../public/images/noSearchResults.jpg";
import BackupTableRoundedIcon from "@mui/icons-material/BackupTableRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useSelector } from "react-redux";
import { State } from "../../../../../shell/store/media-revamp";
interface Props {
  searchTerm: string;
}
export const SearchEmptyState = ({
  searchTerm
}: Props) => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const isSelectDialog = useSelector((state: {
    mediaRevamp: State;
  }) => state.mediaRevamp.isSelectDialog);
  return <Box display="flex" justifyContent="center" alignItems="center" height="100%" textAlign={"center"} data-sentry-element="Box" data-sentry-component="SearchEmptyState" data-sentry-source-file="SearchEmptyState.tsx">
      <Box width="387px" data-sentry-element="Box" data-sentry-source-file="SearchEmptyState.tsx">
        <img src={noSearchResults} height="200px" />
        <Typography sx={{
        mt: 4
      }} variant="h4" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="SearchEmptyState.tsx">
          {t("media.searchEmptyStateTitle", {
          searchTerm
        })}
        </Typography>
        <Typography sx={{
        mt: 1,
        mb: 3
      }} variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="SearchEmptyState.tsx">
          {t("media.searchEmptyStateDescription")}
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center" data-sentry-element="Stack" data-sentry-source-file="SearchEmptyState.tsx">
          {!isSelectDialog && <Button color="inherit" variant="contained" startIcon={<BackupTableRoundedIcon color="action" />} onClick={() => history.push("/media")}>
              {t("media.goToAllMedia")}
            </Button>}
          <Button variant="contained" startIcon={<SearchRoundedIcon />} onClick={() => history.push(`/media/search?term=${searchTerm}&cf=true`)} data-sentry-element="Button" data-sentry-source-file="SearchEmptyState.tsx">
            {t("common.searchAgain")}
          </Button>
        </Stack>
      </Box>
    </Box>;
};